import { render, staticRenderFns } from "./AlarmCreated.vue?vue&type=template&id=95a7111c&scoped=true"
import script from "./AlarmCreated.vue?vue&type=script&lang=js"
export * from "./AlarmCreated.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AlarmCreated.vue?vue&type=style&index=1&id=95a7111c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a7111c",
  null
  
)

/* custom blocks */
import block0 from "./AlarmCreated.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports